import styled from 'styled-components';
import { Stack } from '../index';

export const TopSection = styled(Stack)`
    border: ${({ theme }) => `${theme.border.width.standard}${theme.units} solid ${theme.palette.border.light}`};
    border-radius: ${({ theme }) => `${theme.border.radius(3)}${theme.units}`};
`;
